import React from 'react';
import { ReactComponent as CheckIcon } from '../../assets/icons/svg/shared/ic-shared-checkmark.svg';

export interface IProps {
  id: string;
  title: string;
  onClick: (_a: string) => void;
  checked?: boolean;
  className?: string;
}

const RadioButton = ({ id, title, checked, className, onClick }: IProps) => (
  <div id={`container-${id}`} key={`Login-${title}-${id}`} className={`flex items-center ${className}`}>
    <input id={id} type='radio' name='radio' className='hidden' defaultChecked={checked} onClick={() => onClick(id)} />
    <label htmlFor={id} className='flex items-center cursor-pointer text-bw07 h-[26px]'>
      <span className='w-[28px] h-[28px] inline-block rounded-full border border-bw04 hover:bg-bw01 hover:border-bw07 text-bw03 mr-[8px] relative'>
        {checked && (
          <CheckIcon className='text-bw00 w-[70%] absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 z-50' />
        )}
      </span>
      {title}
    </label>
  </div>
);

export default RadioButton;
